import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    fetchMore: 'Load more',
    noScheduledTransfers: 'No active scheduled transfers',
    noScheduledTransfersDescription: 'Find your scheduled transfers here',
    title: 'Scheduled transfers',
    toBeneficiary: 'To {beneficiary}',
  },
  fr: {
    fetchMore: 'Charger davantage',
    noScheduledTransfers: 'Aucun virement programmé actif',
    noScheduledTransfersDescription: 'Retrouvez vos virements programmés ici',
    title: 'Virements programmés',
    toBeneficiary: 'Vers {beneficiary}',
  },
} as const);

export default locales;
